<template>
  <div>Tải xuống mẫu nhập điểm</div>
</template>

<script>
import { mapState } from 'vuex'
import { get } from 'lodash'
import ExcelJS from 'exceljs'
import moment from 'moment'

const CELL_BORDER = {
  top: { style: 'thin' },
  left: { style: 'thin' },
  bottom: { style: 'thin' },
  right: { style: 'thin' }
}
const HEADER_ROW_START = 5
const SUBHEADER_ROW_START = 6
const DATA_ROW_START = 7
const HEADER_FIXED_COL_LABELS = 'ABCDE'

export default {
  props: { query: { type: Object, default: () => {} } },
  data: () => ({ list: [], factorsRaw: [] }),
  computed: { ...mapState('ClassMarkInput', ['studentMarks', 'factors', 'isClassExtraCurriculum']) },
  methods: {
    getShortTitle(type = '') {
      switch (type) {
        case 'factor-1':
          return 'ĐĐGtx'
        case 'factor-2':
          return 'ĐĐGgk'
        case 'factor-3':
          return 'ĐĐGck'
        default:
          return ''
      }
    },
    async getData() {
      this.factorsRaw = Object.values(this.factors).map(v => ({ ...v, short_title: this.getShortTitle(v.type) }))
      if (this.studentMarks.length) {
        this.list = this.studentMarks.map(v => ({
          student: v.student,
          marks: v.marks.map(x => ({ value: get(x, 'value', ''), factor: get(x, 'factor.id') }))
        }))
        this.onExportExcel()
      }
    },

    getInfo() {
      const className = get(this.query, 'class.title', '')
      const schoolYear = get(this.query, 'semester.schoolYear.description', '')
      const semester = get(this.query, 'semester.title', '')
      const subject = get(this.query, 'subject.title', '')
      const subjectGroup = get(this.query, 'subject.subjectGroup.title', '')
      return { className, schoolYear, semester, subject, subjectGroup }
    },

    // 3 rows
    getTitle(worksheet, totalCols = 7) {
      const { className, schoolYear, semester, subjectGroup } = this.getInfo()
      const description11 = 'Phường Yên Hòa'
      const description12 = 'Trường: THPT Lý Thái Tổ'
      const description13 = `Lớp: ${className}`

      const description21 = 'BẢNG ĐIỂM HỌC KỲ'
      const description22 = schoolYear && semester ? `${schoolYear} - ${semester}` : ''
      const description23 = `Môn học: ${subjectGroup} - GV: Quản trị đơn vị`

      worksheet.addRow([description11, '', '', description21, '', ''])
      worksheet.mergeCells(1, 1, 1, 3)
      worksheet.mergeCells(1, 4, 1, totalCols)

      worksheet.addRow([description12, '', '', description22, '', ''])
      worksheet.mergeCells(2, 1, 2, 3)
      worksheet.mergeCells(2, 4, 2, totalCols)

      worksheet.addRow([description13, '', '', description23, '', ''])
      worksheet.mergeCells(3, 1, 3, 3)
      worksheet.mergeCells(3, 4, 3, totalCols)

      worksheet.getCell('A1').alignment = { horizontal: 'left' }
      worksheet.getCell('A1').font = { name: 'Times New Roman' }
      worksheet.getCell('D1').alignment = { horizontal: 'center' }
      worksheet.getCell('D1').font = { name: 'Times New Roman', bold: true }

      worksheet.getCell('A2').alignment = { horizontal: 'left' }
      worksheet.getCell('A2').font = { name: 'Times New Roman' }
      worksheet.getCell('D2').alignment = { horizontal: 'center' }
      worksheet.getCell('D2').font = { name: 'Times New Roman' }

      worksheet.getCell('A3').alignment = { horizontal: 'left' }
      worksheet.getCell('A3').font = { name: 'Times New Roman' }
      worksheet.getCell('D3').alignment = { horizontal: 'center' }
      worksheet.getCell('D3').font = { name: 'Times New Roman' }

      worksheet.addRow([])
    },

    setHeader(worksheet) {
      worksheet.getRow(HEADER_ROW_START).eachCell(cell => {
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }
        cell.font = { name: 'Times New Roman', bold: true }
        cell.border = {
          top: { style: 'thin' },
          left: { style: 'thin' },
          bottom: { style: 'thin' },
          right: { style: 'thin' }
        }

        const selectedHeaders = ['STT', 'Mã định danh Bộ GD&ĐT', 'Họ và tên', 'Ngày sinh']
        if (this.isClassExtraCurriculum) selectedHeaders.push('Lớp')
        if (selectedHeaders.includes(cell.value)) {
          cell.font = { name: 'Times New Roman', bold: true, color: { argb: 'FFFF0000' } }
        } else {
          cell.font = { name: 'Times New Roman', bold: true }
        }
      })
    },

    settingCells(worksheet, colIndex = 1) {
      // set no (STT)
      worksheet.getColumn(1).eachCell((cell, rowNumber) => {
        if (rowNumber >= DATA_ROW_START) cell.alignment = { horizontal: 'center', vertical: 'middle' }
      })
      // set height for header row
      worksheet.getRow(HEADER_ROW_START).height = 60

      const totalCols = worksheet.columns.length
      worksheet.eachRow((row, rowNumber) => {
        if (rowNumber >= HEADER_ROW_START) {
          // set border for main table
          row.eachCell(cell => {
            cell.border = CELL_BORDER
            cell.font = { name: 'Times New Roman' }
          })
        }

        // set align center for marks
        if (rowNumber >= DATA_ROW_START) {
          for (let i = colIndex; i < totalCols; i++) {
            row.getCell(i + 1).alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }
          }
        }
      })
      // set subheader style
      worksheet.getRow(SUBHEADER_ROW_START).eachCell(cell => {
        cell.alignment = { horizontal: 'center', vertical: 'middle', wrapText: true }
        cell.font = { name: 'Times New Roman', bold: true }
      })
    },

    setWorksheetColumnWidth({ worksheet, remainingCount = 0 }) {
      worksheet.columns = [
        { width: 10 },
        { width: 12 },
        { width: 30 },
        { width: 15 },
        ...Array(remainingCount).fill({ width: 8 })
      ]
    },

    getMarkValue({ mark = {}, isEvaluate = false }) {
      let markValue = ''
      if (!isEvaluate) markValue = get(mark, 'value', '')
      else {
        const meaning = this.$options.filters.getEvaluate(mark.value)
        if (meaning !== '---') markValue = meaning
      }
      return markValue
    },
    getContentDataRow({ factors, maxCounts, student, index, isEvaluate = false }) {
      let row = [
        String(index + 1),
        student.student.code,
        student.student.name,
        moment(student.student.dob).format('DD/MM/YYYY')
      ]
      //
      if (this.isClassExtraCurriculum) row.push(get(student, 'student.currentClassTitle', ''))
      //
      factors.forEach((factor, factorIndex) => {
        const marks = student.marks.filter(mark => mark.factor === factor.id && mark.value !== '')
        const maxColumns = Number(maxCounts[factorIndex])
        // fill each colum with mark (if any)
        if (Array.isArray(marks) && marks.length)
          marks.forEach(mark => row.push(this.getMarkValue({ mark, isEvaluate })))
        // fill remaining columns with empty string
        row = row.concat(Array(Math.max(maxColumns - marks.length, 0)).fill(''))
      })
      //
      return row
    },

    async onExportExcel() {
      const workbook = new ExcelJS.Workbook()
      const worksheet = workbook.addWorksheet('Marks')

      const header = ['STT', 'Mã định danh Bộ GD&ĐT', 'Họ và tên', 'Ngày sinh']
      if (this.isClassExtraCurriculum) header.push('Lớp')
      const factors = this.factorsRaw.map(v => ({ id: v.id, title: v.short_title, isOverDefault: v.isOverDefault }))
      const marksHeader = []
      const marksData = []
      const maxCounts = Array(factors.length).fill(0)
      this.list.forEach(student => {
        factors.forEach((factor, factorIndex) => {
          const subtract = factor.isOverDefault ? 2 : 0
          const count = student.marks.filter(mark => mark.factor === factor.id).length - subtract
          maxCounts[factorIndex] = Math.max(maxCounts[factorIndex], count, 1)
        })
      })

      factors.forEach((factor, index) => {
        marksHeader.push(factor.title)
        for (let i = 0; i < maxCounts[index] - 1; i++) marksHeader.push('')
      })

      const isEvaluate = get(this.query, 'subject.markType') === 'evaluate'
      this.list.forEach((student, index) =>
        marksData.push(this.getContentDataRow({ factors, maxCounts, student, index, isEvaluate }))
      )

      let numNthRows = Array(header.length).fill('')
      factors.forEach(
        (_, index) => (numNthRows = numNthRows.concat(Array.from({ length: maxCounts[index] }, (_, idx) => idx + 1)))
      )

      this.getTitle(worksheet, header.length + marksHeader.length)

      worksheet.addRow(header.concat(marksHeader))
      worksheet.addRow(numNthRows)
      marksData.forEach(row => worksheet.addRow(row))

      const originalColIndex = header.length
      let colIndex = header.length
      for (let i = 0; i < colIndex; i++) {
        const label = HEADER_FIXED_COL_LABELS[i]
        worksheet.mergeCells(`${label}${HEADER_ROW_START}:${label}${HEADER_ROW_START + 1}`)
      }
      factors.forEach((_, index) => {
        if (maxCounts[index] > 1) {
          worksheet.mergeCells(HEADER_ROW_START, colIndex + 1, HEADER_ROW_START, colIndex + maxCounts[index])
        }
        colIndex += maxCounts[index]
      })

      this.settingCells(worksheet, originalColIndex)
      this.setHeader(worksheet)
      this.setWorksheetColumnWidth({ worksheet, remainingCount: marksHeader.length })

      this.onDownload(workbook)
    },

    async onDownload(workbook) {
      const { className, semester, subjectGroup } = this.getInfo()
      const buffer = await workbook.xlsx.writeBuffer()
      const blob = new Blob([buffer], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `Bảng điểm ${subjectGroup} lớp ${className} ${semester}.xlsx`
      link.click()
      this.$emit('onExportSuccess')
    }
  }
}
</script>
